import { CircularProgress, Dialog, Grid, Typography } from "@material-ui/core";
import React from "react";
import { HorizontalCentered } from "./HorizontalCentered";
import { VerticalCenter } from "./VerticalCenter";

export function LoadingDialog(props:{text?:string}){
    return (
        <Dialog open={true} disableEscapeKeyDown={true} >
            <Grid container style={{height: 150, width: 150}}>
                <VerticalCenter>
                    <HorizontalCentered>
                        <CircularProgress />
                    </HorizontalCentered>
                    <Typography align="center" >{props.text ? props.text : "Loading..."}</Typography>
                </VerticalCenter>
            </Grid>
        </Dialog>
    )
}